import validator from 'validator';

export const newsletterSignup =() => {
    const newsletterModules = document.querySelectorAll('.m__newsletter');

    if ( newsletterModules ) {        
        newsletterModules.forEach(mod => {
            const newsletterSignupForm = mod.querySelector('.js__newsletter__form');

            if ( newsletterSignupForm ) {
                newsletterSignupForm.addEventListener('submit', (e) => {
                    e.preventDefault();

                    newsletterSignupForm.classList.add('submitting');

                    setTimeout(() => {
                        newsletterSignupForm.classList.add('hidden');
                    }, 400);

                    grecaptcha.ready(function() {
                        grecaptcha.execute(igniteRecaptchaKey, {action: 'newsletterSignup'}).then(function(token) {

                            let formData = new FormData(newsletterSignupForm);
                            let isFormValid = true;

                            //Reset any errors
                            for (var [key, value] of formData.entries()) {
                                if (key != 'locations' && key != 'events') {
                                    let inputToCheck = document.querySelector('#' + key);
                                    if (inputToCheck.required) {
                                        inputToCheck.classList.remove('error');
                                    }
                                }
                            }

                            //Check for any required fields left blank
                            for (var [key, value] of formData.entries()) {
                                let inputToCheck = document.querySelector('#' + key);
                                
                                if (!value || value == '' || value == '#') {
                                    if (inputToCheck.required) {
                                        isFormValid = false;
                                        inputToCheck.classList.add('error');

                                        if(key == 'BrandID'){
                                            alert('Please select a location');
                                        }
                                    }
                                }else{
                                    if(inputToCheck.type == 'email'){
                                        if(!validator.isEmail(value)){
                                            isFormValid = false;
                                            inputToCheck.classList.add('error');
                                        }
                                    }else if(inputToCheck.type == 'text'){
                                        if(!validator.isAlphanumeric(value)){
                                            isFormValid = false;
                                            inputToCheck.classList.add('error');
                                        }
                                    }
                                }
                            }

                            //Pass through the recaptcha token
                            formData.append('recaptcha',token);

                            if (isFormValid) {
                                fetch(igniteAjax.ajaxurl, {
                                    method: 'POST',
                                    body: formData,
                                })
                                    .then((response) => response.json())
                                    .then((data) => {
                                        if (data.ResponseStatus) {
                                            mod.querySelector('.m__newsletter__success').classList.remove('hidden');
                                        } else {
                                            mod.querySelector('.m__newsletter__fail').classList.remove('hidden');
                                        }
                                    })
                                    .catch((error) => {
                                        mod.querySelector('.m__newsletter__fail').classList.remove('hidden');
                                    });
                            }
                        });
                    });
                });
            }
        });
    }


	const newsletterSubmitButton = document.querySelector('.js__signup'),
		newsletterSignupForm = document.querySelector('#newsletter-signup-form'),
		newsletterThankyou = document.querySelector('#js__newsletter-thankyou'),
		newsletterLocationSelect = document.querySelector('#BrandID');
		popup = document.querySelector('.popup#newsletter');
	/* if(newsletterLocationSelect){
		const choicesConfig = {
			itemSelectText: '',
			shouldSort: false,
			searchEnabled: false,
		};		
		newsletterLocationSelectChoices = new Choices(newsletterLocationSelect,choicesConfig);
	} */

	if(newsletterSubmitButton && newsletterSignupForm){

		newsletterSignupForm.addEventListener('submit',(event) => {
			event.preventDefault();

			newsletterSignupForm.classList.add('submitting');

			grecaptcha.ready(function() {
          		grecaptcha.execute(igniteRecaptchaKey, {action: 'newsletterSignupForm'}).then(function(token) {

					let formData = new FormData(newsletterSignupForm);
					let isFormValid = true;

					//Reset any errors
					for (var [key, value] of formData.entries()) {
						if (key != 'locations' && key != 'events') {
							let inputToCheck = document.querySelector('#' + key);
							if (inputToCheck.required) {
								inputToCheck.classList.remove('error');
							}
						}
					}

					//Check for any required fields left blank
					for (var [key, value] of formData.entries()) {
						let inputToCheck = document.querySelector('#' + key);
						
						if (!value || value == '' || value == '#') {
							if (inputToCheck.required) {
								isFormValid = false;
								inputToCheck.classList.add('error');

								if(key == 'BrandID'){
									alert('Please select a location');
								}
							}
						}else{
							if(inputToCheck.type == 'email'){
								if(!validator.isEmail(value)){
									isFormValid = false;
									inputToCheck.classList.add('error');
								}
							}else if(inputToCheck.type == 'text'){
								if(!validator.isAlphanumeric(value)){
									isFormValid = false;
									inputToCheck.classList.add('error');
								}
							}
						}
					}

						


					//Pass through the recaptcha token
					formData.append('recaptcha',token);

					if (isFormValid) {
						fetch(igniteAjax.ajaxurl, {
							method: 'POST',
							body: formData,
						})
							.then((response) => response.json())
							.then((data) => {
								newsletterSignupForm.classList.remove('submitting');
								if (data.ResponseStatus) {
									popup.querySelector('.popup__title').classList.add('hidden');
									newsletterSignupForm.classList.add('hidden');
									newsletterThankyou.classList.remove('hidden');
								} else {
									newsletterSignupForm.classList.remove('hidden');
									newsletterThankyou.classList.add('hidden');
								}
							})
							.catch((error) => {
								console.error(error);
								newsletterSignupForm.classList.remove('submitting');
							});
					}
				});
	        });

		})

	}
}